/**
 * Created by robert.lavoie on 9/8/17.
 */

import { Directive, ElementRef, Output, Input, EventEmitter, HostListener } from '@angular/core';

@Directive({
  selector: '[ClickOutside]'
})
export class ClickOutsideDirective {

  constructor(private elementRef: ElementRef) {}

  @Output()
	public clickOutside = new EventEmitter<any>();

  @Input()
  public hidden: boolean;

  @HostListener('document:click', ['$event', '$event.target']) onClick(event: any, targetElement: any) {

    const clickedInside = this.elementRef.nativeElement.contains(targetElement);

    if (!clickedInside && !this.hidden) {
      this.clickOutside.emit(null);
    }

  }
}